import {createStore} from 'vuex'
import data from '@/data'

import getters from '@/store/getters'
import actions from '@/store/actions'
import mutations from '@/store/mutations'

export default createStore({
    state: {
        ...data,
        title: '',
        authId: null,
        userId: null,
        contactNames: null,
        userUid: null,
        userPermission: null,
        userRole: null,
        userToken: null,
        tokenExpiration: null,
        contact: [],
        supplier: [],
        batch: [],
        regrater: [],
        setting: [],
        report: [],
        product: [],
        appSetting: null,
        appApiBase: null,
        appInstance: null,
        stockLocations: []
    },
    getters,
    actions,
    mutations
})